import update from 'immutability-helper';

import {BenchlingAction} from 'redux-stores/Action';

import {InsightsBlockEditorActionType} from './BlockEditorReduxActions';
import {SQLTemplateFormState} from './sql-template-form/SQLTemplateFormTypes';

export interface BlockEditorUIState {
  sqlTemplateFormState?: SQLTemplateFormState;
  sqlQueryOverride?: string;
}

export interface BlockEditorUIsState {
  [analyticsQueryId: string]: BlockEditorUIState;
}

export const DEFAULT_BLOCK_EDITOR_UI_STATE = {};

export const BLOCK_EDITOR_UIS_INITIAL_STATE = {};

export default function reduceBlockEditorUIs(
  state: BlockEditorUIsState = BLOCK_EDITOR_UIS_INITIAL_STATE,
  action: BenchlingAction
): BlockEditorUIsState {
  switch (action.type) {
    case InsightsBlockEditorActionType.INSIGHTS_DELETE_SQL_TEMPLATE_FORM: {
      const {sqlTemplateFormState, ...remainingState} = state[action.analyticsQueryId];
      return {
        ...state,
        [action.analyticsQueryId]: {
          ...remainingState,
        },
      };
    }
    case InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_TEMPLATE_FORM:
      return {
        ...state,
        [action.analyticsQueryId]: {
          ...state[action.analyticsQueryId],
          sqlTemplateFormState: action.sqlTemplateFormState,
        },
      };
    case InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_QUERY_OVERRIDE:
      return {
        ...state,
        [action.analyticsQueryId]: {
          ...state[action.analyticsQueryId],
          sqlQueryOverride: action.sqlQueryOverride,
        },
      };
    case InsightsBlockEditorActionType.INSIGHTS_RESET_SQL_QUERY_OVERRIDE:
      return {
        ...state,
        [action.analyticsQueryId]: update(
          {...state[action.analyticsQueryId]},
          {$unset: ['sqlQueryOverride']}
        ),
      };
    default:
      return state;
  }
}
